import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";

const stats = [
  "India's Edu-tech industry is expected to reach a feet of USD 1.96 billion with 9.6 million users in its account.",
  "The next 500 million school going internet users will adopt native language based e-learning for their academics.",
  "Indian Edu-Tech industry will witness 22.7 billion downloads of study materials in various formats by 2021 post the arrival of bite-sized learning.",
  "At present the primary and secondary school students are the second major target (24%) for edu-tech software providers in India — this number would get further increased and reach no.1 position with a raise of 60%.",
  "In India around 44% of education related search are coming from outside of top-six metros in India.",
];

const SmsEdutechStats: React.FC = () => {
  return (
    <section className="sms-stats" aria-labelledby="sms-stats-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2 id="sms-stats-title" className="wdev-section-head__title wdev-section-head__title--dark">
            Stats on Edu-Tech Industry
          </h2>
          <p className="sms-stats__lead">
            Since the academic industry is delivering numerous benefits to students by embracing
            emerging technologies, it is high time for budding aspirants and technologically
            stagnated players to adopt full-fledged web designing and web app development services
            to register as a strong school management system in India.
          </p>
        </AnimatedSection>

        <ul className="sms-stats__list">
          {stats.map((stat, index) => (
            <motion.li
              key={index}
              className="sms-stats__item"
              initial={{ opacity: 0, x: -16 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: index * 0.08 }}
            >
              <span className="sms-stats__bullet" aria-hidden="true" />
              <p>{stat}</p>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default SmsEdutechStats;
